import { i as _slicedToArray, b as _createClass, e as _classCallCheck, _ as _defineProperty } from '../_helpers/_rollupPluginBabelHelpers.js';
import 'core-js/modules/es.array.filter.js';
import 'core-js/modules/es.array.iterator.js';
import 'core-js/modules/es.object.assign.js';
import 'core-js/modules/es.object.entries.js';
import 'core-js/modules/es.object.to-string.js';
import 'core-js/modules/es.regexp.exec.js';
import 'core-js/modules/es.set.js';
import 'core-js/modules/es.string.split.js';
import 'core-js/modules/web.dom-collections.for-each.js';
import 'core-js/modules/web.dom-collections.iterator.js';

/**
 * @name DOM
 */
var getStyles = window.getComputedStyle.bind(window);
function isMounted(node) {
  if (node === document) {
    return true;
  }
  return node instanceof Node && document.documentElement.contains(node.parentNode);
}
var rectStub = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  width: 0,
  height: 0
};
function getRect(node) {
  if (node instanceof Range || node != null && isMounted(node)) {
    var _node$getBoundingClie = node.getBoundingClientRect(),
      top = _node$getBoundingClie.top,
      right = _node$getBoundingClie.right,
      bottom = _node$getBoundingClie.bottom,
      left = _node$getBoundingClie.left,
      width = _node$getBoundingClie.width,
      height = _node$getBoundingClie.height;
    return {
      top,
      right,
      bottom,
      left,
      width,
      height
    };
  } else {
    return Object.assign({}, rectStub);
  }
}
function getPixelRatio() {
  return 'devicePixelRatio' in window ? window.devicePixelRatio : 1;
}
function getWindowHeight() {
  return window.innerHeight;
}
function getWindowWidth() {
  return window.innerWidth;
}
function isNodeInVisiblePartOfPage(node) {
  var _getRect = getRect(node),
    top = _getRect.top,
    bottom = _getRect.bottom,
    left = _getRect.left,
    right = _getRect.right;
  return !(bottom < 0 || right < 0 || getWindowHeight() - top < 0 || getWindowWidth() - left < 0);
}
function getDocumentScrollTop() {
  return document.documentElement && document.documentElement.scrollTop || document.body.scrollTop;
}
function getDocumentScrollLeft() {
  return document.documentElement && document.documentElement.scrollLeft || document.body.scrollLeft;
}
var applyMethodToClasses = function applyMethodToClasses(method) {
  return function (classList) {
    var classes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    classes.split(/\s+/g).filter(function (className) {
      return !!className;
    }).forEach(function (className) {
      return classList[method](className);
    });
  };
};
var addClasses = applyMethodToClasses('add');
var removeClasses = applyMethodToClasses('remove');
var toggleClasses = function toggleClasses(classList, classes) {
  return Object.entries(classes).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      className = _ref2[0],
      on = _ref2[1];
    return classList.toggle(className, on);
  });
};
function setRootStyleProperties() {
  var properties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var rootStyle = document.documentElement.style;
  Object.entries(properties).forEach(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
      key = _ref4[0],
      value = _ref4[1];
    rootStyle.setProperty(key, value);
  });
}
function resetRootStyleProperties() {
  var properties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var rootStyle = document.documentElement.style;
  Object.keys(properties).forEach(function (key) {
    return rootStyle.removeProperty(key);
  });
}
var Listeners = /*#__PURE__*/function () {
  function Listeners() {
    _classCallCheck(this, Listeners);
    _defineProperty(this, "_all", new Set());
  }
  return _createClass(Listeners, [{
    key: "add",
    value: function add(el, event, handler, options) {
      el.addEventListener(event, handler, options);
      var dispatchFn = function dispatchFn() {
        return el.removeEventListener(event, handler, options);
      };
      this._all.add(dispatchFn);
      return dispatchFn;
    }
  }, {
    key: "remove",
    value: function remove(fn) {
      fn();
      this._all.delete(fn);
    }
  }, {
    key: "removeAll",
    value: function removeAll() {
      var _this = this;
      this._all.forEach(function (fn) {
        return _this.remove(fn);
      });
    }
  }]);
}();
// Synthetic events from Combokeys#trigger are plain objects
function preventDefault(e) {
  if (e.preventDefault) {
    e.preventDefault();
  }
}

export { Listeners, addClasses, applyMethodToClasses, getDocumentScrollLeft, getDocumentScrollTop, getPixelRatio, getRect, getStyles, getWindowHeight, getWindowWidth, isMounted, isNodeInVisiblePartOfPage, preventDefault, removeClasses, resetRootStyleProperties, setRootStyleProperties, toggleClasses };
